// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"9ef3739b","434":"5d9030a2","867":"15a6a522","882":"5536e66b","935":"17447725"}[chunkId] + ".chunk.js";
};